import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type ConsumerBffSpecializationContextType =
  | {
      specializationPage?: ConsumerSpecializationPageFieldsFragment | null | undefined;
      isS12nDataLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

export const ConsumerBffSpecializationContext = React.createContext<ConsumerBffSpecializationContextType>(undefined);

export const useSpecializationPageData = () => {
  const context = useContext(ConsumerBffSpecializationContext);

  return context?.specializationPage;
};

export const useIsS12nDataLoading = () => {
  const context = useContext(ConsumerBffSpecializationContext);

  return context?.isS12nDataLoading;
};

export const useS12nPageError = () => {
  const context = useContext(ConsumerBffSpecializationContext);

  return context?.error;
};

export default ConsumerBffSpecializationContext;
